module.exports = __webpack_public_path__ + "static/media/mem6.1481f9cf.jpg";